module.exports = __webpack_public_path__ + "static/media/chennai.db9cd36a.png";